/**
 * Rule shared by every schema that lists document lines by id (shipment, receipt, after-sales case,
 * credit note…): one id appears at most once. A repeated id would let a request book more than the
 * line allows, each entry being checked on its own (audit 2026-10-15, STK-1, STK-2, SAV-1, PAT-5).
 *
 * Usage: `z.array(z.object({ lineId: z.uuid(), … })).refine(...uniqueBy("lineId"))`.
 * The message is an i18n key, set on the array itself.
 */
export function uniqueBy<K extends string>(key: K) {
  return [
    (items: readonly ({ [P in K]?: unknown } | null | undefined)[] | null | undefined) => {
      if (!items) return true;
      const seen = new Set<unknown>();
      for (const item of items) {
        const value = item?.[key];
        if (value == null) continue;
        if (seen.has(value)) return false;
        seen.add(value);
      }
      return true;
    },
    { message: "errors.field.duplicateLine" },
  ] as const;
}
